import { render, staticRenderFns } from "./points.vue?vue&type=template&id=e4610bd4&scoped=true"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"
import style0 from "./points.vue?vue&type=style&index=0&id=e4610bd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4610bd4",
  null
  
)

export default component.exports